// src/components/Eventos/EventsHeats/hooks/useAccordionState.js
import { useState } from 'react';

export const useAccordionState = (initialOpenAccordions = new Set(['global_results'])) => {
  const [openAccordions, setOpenAccordions] = useState(initialOpenAccordions);

  const handleAccordionToggle = (accordionId, isOpen) => {
    setOpenAccordions(prev => {
      const newSet = new Set(prev);
      if (isOpen) {
        newSet.add(accordionId);
      } else {
        newSet.delete(accordionId);
      }
      return newSet;
    });
  };

  return {
    openAccordions,
    handleAccordionToggle
  };
};